import { render, staticRenderFns } from "./AyudaPagos.vue?vue&type=template&id=5d1ad0ad"
import script from "./AyudaPagos.vue?vue&type=script&lang=js"
export * from "./AyudaPagos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports